import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Box from '@material-ui/core/Box';
import SubHeader from "../header/subheader";
import DiagramContainer from '../conversation/diagram-container';
import EditConversation from '../conversation/Edit-conversation';
import MessageListener from '../conversation/message-listener';
import useThemeQuery from '../../graphql/queries/toggle-theme';
// import useConversationQuery from '../../graphql/queries/conversation';
import Loading from './loading';
import { conversationsData } from '../../utils/dummyDatas';

const Conversation = ({ params }) => {
    const { data: theme } = useThemeQuery();
    const { formatMessage } = useIntl();
    const [data, setData] = useState(null);

    useEffect(() => {
        setData(conversationsData.conversations.find((conversation) => conversation.conversationId === params.id))
    }, [params.id])
    // const { loading, data } = useConversationQuery({
    //     conversationId: params.id,
    //     timezone:  "Europe/Paris",
    // });

    if (!data) return <Loading />;
    return (
        <Box flexDirection="column" height="100%">
            <SubHeader title={formatMessage({id:"app.subHeader.conversation.detail", defaultMessage: "Conversation details"})} theme={theme && theme.theme} />
            <EditConversation conversation={data} />
            <DiagramContainer />
            <MessageListener 
                theme={theme && theme.theme}
                data={data} 
            />
        </Box>
    )
}

export default Conversation;